import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { IContentLanguageLabelModel } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { ObjectTypes } from '@fi-shared/types';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { Subject } from 'rxjs';
import { Animations } from '@fi-shared/utils/animations';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';

@Component({
    selector: 'fi-checklist2-common-data',
    templateUrl: './common-data.component.html',
    styleUrls: ['./common-data.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist2-common-data' },
    animations: [Animations.fade],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiChecklist2CommonDataComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiChecklist2CommonDataComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiChecklist2CommonDataComponent
    extends ControlValueAccessorValidatorBase<IContentLanguageLabelModel[]>
    implements OnDestroy
{
    // todo: replace with name-description-input
    @Input() modelName: string = 'Name';
    get names(): IContentLanguageLabelModel[] {
        return this.ngModel;
    }
    @Input() descriptions: IContentLanguageLabelModel[] = [];
    @Input() mediaBankFileReferences: IMediaBankFileReference[] = [];
    @Output() mediaBankFileReferencesChange = new EventEmitter<IMediaBankFileReference[]>();
    @Input() selectedLanguageId: number;
    @Input({ required: true }) namePlaceholderTextId: string;
    @Input({ required: true }) namePlaceholderHintTextId: string;
    @Input({ required: true }) descriptionPlaceholderHintTextId: string;
    @Input({ required: true }) showAttachmentsArea: boolean;
    @Input() objectType: ObjectTypes = ObjectTypes.CheckList;
    @Input() nameFormFieldClassName: string;
    @Input() parentDialogClassName: string;

    protected isPreferredContentLangLabelModel(labelModel: IContentLanguageLabelModel): boolean {
        return labelModel.ContentLanguageId === this.selectedLanguageId;
    }

    protected isNameRequired(): boolean {
        return !this.names.find((name: IContentLanguageLabelModel) => name.Value);
    }

    protected onMediaBankFileReferencesChange($event: IMediaBankFileReference[]) {
        this.mediaBankFileReferencesChange.emit($event);
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }

    protected readonly ObjectTypes = ObjectTypes;
}
